import React from "react";

export default function DefHeading({ section }) {
  const { title } = section?.content || {};

  return <h2 className="display-4 mb-3 text-center">{title}</h2>;
}
